export default __webpack_public_path__ + "static/media/blog02.eb7a8060.png";